import axios from 'axios';
// 环境的切换
// if (process.env.NODE_ENV === "development") {
//   // axios.defaults.baseURL = 'http://localhost:8090/tsinghua/';
//    axios.defaults.baseURL = "http://120.24.39.227:8082";
// } else if (process.env.NODE_ENV === "production") {
//   // axios.defaults.baseURL = "http://sdkx-api.1105am.com/app/v1";
//    axios.defaults.baseURL = "http://120.24.39.227:8082";
// }
axios.defaults.withCredentials = true;
// axios.defaults.timeout = 30000;
axios.defaults.headers.post['Content-Type'] = "multipart/form-data, application/json, text/plain, application/octet-stream,*/*;charset=UTF-8";
// var index = layer.load(2, {shade: false}); //0代表加载的风格，支持0-2
//loading层


/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
// axios.interceptors.response.use(
//   response => {
//     response.setHeader("Access-Control-Allow-Origin", "*");//允许访问的来源地址
//     console.log(response)
//     return response
//   },
//   //接口错误状态处理，也就是说无响应时的处理
//   error => {
//     return Promise.reject(error.response.status) // 返回接口返回的错误信息
//   }
// )

export function get(url, params, type, headers ={}) {
  let host = ''
  if(type==1){
    // if (process.env.NODE_ENV === "development") {
    //   host = "http://120.24.39.227:8081/v1";
    // } else if (process.env.NODE_ENV === "production") {
    //   // host = "http://sdkx-api.1105am.com/app/v1";
    //   host = "http://120.24.39.227:8081/v1";
    // }
    host = process.env.BASE_APP_API;
  }else if(type==2){
    // if (process.env.NODE_ENV === "development") {
    //   host = "http://120.24.39.227:8082";
    // } else if (process.env.NODE_ENV === "production") {
    //   // host = "http://sdkx-api.1105am.com/manage";
    //   host = "http://120.24.39.227:8082";
    // }
    host = process.env.BASE_MANAGE_API;
  }else{
    // if (process.env.NODE_ENV === "development") {
    //   host = "http://120.24.39.227:8082";
    // } else if (process.env.NODE_ENV === "production") {
    //   // host = "http://sdkx-api.1105am.com/manage";
    //   host = "http://120.24.39.227:8082";
    // }
    host = process.env.BASE_MANAGE_API;
  }
  return new Promise((resolve, reject) => {
    axios.get(host+url, {
      params: params,
      headers
    }).then(res => {
      resolve(res);
    }).catch(err => {
      reject(err)
    })
  });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, data, type, headers) {
  let host = ''
  if (type == 1) {
    // if (process.env.NODE_ENV === "development") {
    //   // axios.defaults.baseURL = 'http://localhost:8090/tsinghua/';
    //   host = "http://120.24.39.227:8081/v1";
    // } else if (process.env.NODE_ENV === "production") {
    //   // host = "http://sdkx-api.1105am.com/app/v1";
    //   host = "http://120.24.39.227:8081/v1";
    // }
    host = process.env.BASE_APP_API;
  } else if (type == 2) {
    // if (process.env.NODE_ENV === "development") {
    //   // axios.defaults.baseURL = 'http://localhost:8090/tsinghua/';
    //   host = "http://120.24.39.227:8082";
    // } else if (process.env.NODE_ENV === "production") {
    //   // host = "http://sdkx-api.1105am.com/manage";
    //   host = "http://120.24.39.227:8082";
    // }
    host = process.env.BASE_MANAGE_API;
  } else {
    // if (process.env.NODE_ENV === "development") {
    //   host = "http://120.24.39.227:8082";
    // } else if (process.env.NODE_ENV === "production") {
    //   // host = "http://sdkx-api.1105am.com/manage";
    //   host = "http://120.24.39.227:8082";
    // }
    host = process.env.BASE_MANAGE_API;
  }
  // return new Promise((resolve, reject) => {
  //   axios.post(host+url, data, headers, {withCredentials: true})
  //     .then(res => {
  //       // console.log(res)
  //       resolve(res);
  //     })
  //     .catch(err => {
  //       reject(err)
  //     })
  // });
  return new Promise((resolve, reject) => {
    axios.post(host+url, data, headers, {withCredentials: true})
      .then(res => {
        // console.log(res)
        resolve(res);
      })
      .catch(err => {
        reject(err)
      })
  });
}


//////////////////
// WEBPACK FOOTER
// ./static/common/http.js
// module id = null
// module chunks = 